<template>
  <div class="home">

    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-inner">
        <!-- 左侧内容 -->
        <div class="hero-left">
          <div class="hero-badge">
            <svg class="badge-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/>
            </svg>
            <span>极客码艺 - 毕设管家</span>
          </div>
          <p class="hero-desc">
            <span class="desc-normal">如今市场上技术人员众多，代码开发能力普遍相差无几，</span><br/>
            <span class="desc-normal">所以在这个赛道上，我深知</span><span class="desc-highlight">服务品质与售后支持</span><span class="desc-normal">才是最关键的。</span><br/>
            <span class="desc-label">我们的服务宗旨：</span><br/>
            <span class="desc-slogan">咨询由你开口，难题我来接手！</span><br/>
            <span class="desc-slogan">你放一万个心，其余让我们来操心！</span>
          </p>
          <div class="hero-btns">
            <button class="btn-primary" @click="showContact = true">程序定制</button>
            <button class="btn-manual" @click="showManual = true">操作手册</button>
          </div>
        </div>

        <!-- 右侧代码窗口 -->
        <div class="code-window">
          <div class="code-header">
            <div class="code-dots">
              <span class="dot red"></span>
              <span class="dot yellow"></span>
              <span class="dot green"></span>
            </div>
            <span class="code-filename">geek-coding-system.java</span>
          </div>
          <div class="code-body">
            <div><span class="c-purple">import</span> <span class="c-yellow">org.springframework.boot.SpringApplication</span>;</div>
            <div><span class="c-purple">import</span> <span class="c-yellow">org.springframework.boot.autoconfigure.SpringBootApplication</span>;</div>
            <div class="mt">
              <div class="c-yellow">@SpringBootApplication</div>
              <div class="c-gray"><span class="c-purple">public</span> <span class="c-purple">class</span> <span class="c-blue">Application</span> {</div>
              <div class="indent1 c-gray"><span class="c-purple">public static void</span> <span class="c-yellow">main</span>(String[] args) {</div>
              <div class="indent2 c-gray">SpringApplication.run(Application.<span class="c-purple">class</span>, args);</div>
              <div class="indent2 c-gray">System.out.println(<span class="c-green">"--- Geek Code Core System Started ---"</span>);</div>
              <div class="indent2 c-gray">System.out.println(<span class="c-green">"技术驱动 · 严谨开发"</span>);</div>
              <div class="indent2 c-gray">System.out.println(<span class="c-green">"极客码艺工作室"</span>);</div>
              <div class="indent2 c-gray"><span class="c-purple">logger</span>.info(<span class="c-green">"服务启动成功，端口：8080"</span>);</div>
              <div class="indent2 c-gray"><span class="c-purple">logger</span>.info(<span class="c-green">"数据库连接池初始化完成"</span>);</div>
              <div class="indent1 c-gray">}</div>
              <div class="c-gray">}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 工作室介绍 -->
    <section class="section bg-gray">
      <div class="section-inner">
        <div class="section-header">
          <h2>工作室介绍</h2>
          <p>秉承专业、严谨的态度，为您提供优质的技术服务。</p>
        </div>
        <div class="grid-4">
          <div class="intro-card" v-for="item in introItems" :key="item.title">
            <div class="intro-corner" :style="{ backgroundColor: item.cornerColor }"></div>
            <div class="intro-header">
              <div class="intro-icon" :style="{ backgroundColor: item.iconBg }">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" :style="{ color: item.iconColor }">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.icon"/>
                </svg>
              </div>
              <h3 class="intro-title">{{ item.title }}</h3>
            </div>
            <p class="intro-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术栈 -->
    <section class="section bg-dot">
      <div class="section-inner">
        <div class="section-header">
          <h2>我们会的</h2>
          <p>多元化的技术栈，覆盖从嵌入式到全栈云端的全生态开发能力。</p>
        </div>
        <div class="grid-3">
          <div class="tech-card" v-for="item in techItems" :key="item.title">
            <div class="tech-header">
              <div class="tech-icon" :style="{ backgroundColor: item.iconBg }">
                <img :src="item.img" :alt="item.title" />
              </div>
              <h3 :style="{ color: item.titleColor }">{{ item.title }}</h3>
            </div>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 论文助手 -->
    <section class="section bg-gray">
      <div class="section-inner">
        <div class="section-header">
          <h2>论文助手</h2>
          <p>AI 驱动的智能论文辅助工具，助力高效完成毕业设计</p>
        </div>
        <div class="grid-5">
          <div class="helper-card" v-for="item in helperItems" :key="item.title">
            <div class="helper-corner" :style="{ backgroundColor: item.cornerColor }"></div>
            <div class="helper-header">
              <h3 class="helper-title">{{ item.title }}</h3>
              <div class="helper-icon">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" :style="{ color: item.iconColor }">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.icon"/>
                </svg>
              </div>
            </div>
            <p class="helper-desc">{{ item.desc }}</p>
          </div>
        </div>
        <div class="helper-cta">
          <button class="btn-primary" @click="$router.push('/helper')">立即体验论文助手</button>
        </div>
      </div>
    </section>

    <!-- 服务特色 -->
    <section class="section bg-dot">
      <div class="section-inner">
        <div class="section-header">
          <h2>服务特色</h2>
          <p>专业团队，全程护航，让您的毕设之路更加顺畅</p>
        </div>
        <div class="grid-4">
          <div class="feature-card" v-for="item in featureItems" :key="item.title">
            <div class="feature-top">
              <div class="feature-icon" :style="{ backgroundColor: item.iconBg }">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" :style="{ color: item.iconColor }">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="item.icon"/>
                </svg>
              </div>
              <div>
                <div class="feature-num" :style="{ color: item.iconColor }">{{ item.num }}</div>
                <div class="feature-title">{{ item.title }}</div>
              </div>
            </div>
            <p class="feature-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 快速联系模态框 -->
    <ContactModal :visible.sync="showContact" />

    <!-- 操作手册模态框 -->
    <ManualModal :visible.sync="showManual" />

  </div>
</template>

<script>
import ContactModal from "@/components/ContactModal";
import ManualModal from "@/components/ManualModal";

export default {
  name: 'Home',
  components: { ContactModal, ManualModal },
  data() {
    return {
      showContact: false,
      showManual: false,
      introItems: [
        {
          title: '专注技术本质',
          desc: '不只是完成任务，更注重技术原理解析，帮助您真正掌握核心技术。',
          icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
          iconBg: '#dbeafe', iconColor: '#2563eb', cornerColor: 'rgba(59,130,246,0.08)'
        },
        {
          title: '需求分析讨论',
          desc: '深入沟通，精准把握毕设要求，量身定制最合适的解决方案。',
          icon: 'M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z',
          iconBg: '#f3e8ff', iconColor: '#9333ea', cornerColor: 'rgba(147,51,234,0.08)'
        },
        {
          title: '严谨打磨代码',
          desc: '遵循行业规范，编写高质量、可维护、可扩展的源代码。',
          icon: 'M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4',
          iconBg: '#dcfce7', iconColor: '#16a34a', cornerColor: 'rgba(34,197,94,0.08)'
        },
        {
          title: '全程保驾护航',
          desc: '从开发到答辩，提供全周期的技术支持与指导服务。',
          icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
          iconBg: '#dbeafe', iconColor: '#2563eb', cornerColor: 'rgba(59,130,246,0.08)'
        }
      ],
      techItems: [
        { title: 'Java开发', desc: 'Spring Boot、Spring Cloud、SSM ...', img: require('@/assets/home1.png'), titleColor: '#2563eb', iconBg: '#dbeafe' },
        { title: 'NodeJS项目', desc: 'NodeJS、Express、Koa、NestJS、Vue', img: require('@/assets/home2.png'), titleColor: '#16a34a', iconBg: '#dcfce7' },
        { title: '移动端开发', desc: '原生微信小程序、Uniapp小程序、H5、安卓App', img: require('@/assets/home3.png'), titleColor: '#9333ea', iconBg: '#f3e8ff' },
        { title: 'Python开发', desc: 'Django、Flask、数据分析、数据可视化、爬虫 ...', img: require('@/assets/home4.png'), titleColor: '#ea580c', iconBg: '#ffedd5' },
        { title: '机器学习', desc: '线性回归法、随机森林、决策树、回归算法 ...', img: require('@/assets/home5.png'), titleColor: '#db2777', iconBg: '#fce7f3' },
        { title: '单片机设计', desc: '51单片机、STM32单片机、Linux类开发板 ...', img: require('@/assets/home6.png'), titleColor: '#4b5563', iconBg: '#f3f4f6' },
      ],
      helperItems: [
        {
          title: 'ER图',
          desc: '数据库实体关系图生成',
          icon: 'M5 21h14v-5H5v5zM12 16v-5M12 11a3 3 0 100-6 3 3 0 000 6zM7 16l-3-6M4 10a2 2 0 100-4 2 2 0 000 4zM17 16l3-6M20 10a2 2 0 100-4 2 2 0 000 4z',
          iconBg: '#dbeafe', iconColor: '#2563eb', cornerColor: 'rgba(59,130,246,0.08)'
        },
        {
          title: '三线表',
          desc: '规范学术表格生成',
          icon: 'M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
          iconBg: '#f3e8ff', iconColor: '#9333ea', cornerColor: 'rgba(147,51,234,0.08)'
        },
        {
          title: '功能图',
          desc: '系统功能结构图设计',
          icon: 'M8 2h8v6H8zM12 8v3M3 11h18M3 11v6h6v-6H3zM9 11v6h6v-6H9zM15 11v6h6v-6h-6z',
          iconBg: '#dcfce7', iconColor: '#16a34a', cornerColor: 'rgba(34,197,94,0.08)'
        },
        {
          title: '用例图',
          desc: '系统用例关系图设计',
          icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
          iconBg: '#ffedd5', iconColor: '#ea580c', cornerColor: 'rgba(234,88,12,0.08)'
        },
        {
          title: '流程图',
          desc: '业务逻辑流程图绘制',
          icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01',
          iconBg: '#fce7f3', iconColor: '#db2777', cornerColor: 'rgba(219,39,119,0.08)'
        },
        {
          title: '泳道图',
          desc: '跨部门协作流程图',
          icon: 'M4 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v7a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-3zM14 16a1 1 0 011-1h4a1 1 0 011 1v3a1 1 0 01-1 1h-4a1 1 0 01-1-1v-3z',
          iconBg: '#dbeafe', iconColor: '#2563eb', cornerColor: 'rgba(59,130,246,0.08)'
        },
        {
          title: '时序图',
          desc: '对象交互时序图生成',
          icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
          iconBg: '#f3e8ff', iconColor: '#9333ea', cornerColor: 'rgba(147,51,234,0.08)'
        },
        {
          title: '任务书/开题报告',
          desc: '规范文档自动生成',
          icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
          iconBg: '#dcfce7', iconColor: '#16a34a', cornerColor: 'rgba(34,197,94,0.08)'
        },
        {
          title: '文章生成',
          desc: '论文内容智能撰写',
          icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
          iconBg: '#ffedd5', iconColor: '#ea580c', cornerColor: 'rgba(234,88,12,0.08)'
        },
        {
          title: '降/查AIGC',
          desc: 'AI生成内容检测与降重',
          icon: 'M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01',
          iconBg: '#fce7f3', iconColor: '#db2777', cornerColor: 'rgba(219,39,119,0.08)'
        }
      ],
      featureItems: [
        { num: '01', title: '一对一指导', desc: '专业团队全程陪伴开发，实时解答疑问，确保项目顺利推进', icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253', iconBg: '#dbeafe', iconColor: '#2563eb' },
        { num: '02', title: '部分源码讲解', desc: '提供代码注释与技术文档，助你深入理解系统架构与实现逻辑', icon: 'M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4', iconBg: '#f3e8ff', iconColor: '#9333ea' },
        { num: '03', title: '论文写作辅导', desc: '从结构到内容提供写作建议，规范格式，助力提升论文质量', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z', iconBg: '#dcfce7', iconColor: '#16a34a' },
        { num: '04', title: '贴心售后服务', desc: '提供长期技术支持，保障项目稳定运行，随时响应你的需求', icon: 'M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z', iconBg: '#ffedd5', iconColor: '#ea580c' }
      ]
    }
  },
  created() {
    this.increasePageView()
  },
  methods: {
    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'home' }
      }).catch(() => {})
    },
    handleHelperClick() {
      // 检测是否为移动端
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768

      if (isMobile) {
        // 移动端跳转到提示页面
        this.$router.push('/mobile-not-supported')
      } else {
        // 电脑端跳转到论文助手
        this.$router.push('/diagram')
      }
    }
  }
}
</script>

<style scoped>
.home {
  background: #fff;
}

/* ===== Hero ===== */
.hero {
  background: #fff;
  background-image: linear-gradient(to right, #f0f0f0 1px, transparent 1px),
  linear-gradient(to bottom, #f0f0f0 1px, transparent 1px);
  background-size: 20px 20px;
}

.hero-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 48px 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: start;
}

@media (max-width: 1024px) {
  .hero-inner {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}

.hero-left {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #eff6ff;
  color: #1d4ed8;
  padding: 8px 16px;
  font-size: 30px;
  font-weight: 700;
}

@media (min-width: 768px) { .hero-badge { font-size: 36px; } }
@media (min-width: 1024px) { .hero-badge { font-size: 48px; } }

.badge-icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

@media (min-width: 768px) { .badge-icon { width: 40px; height: 40px; } }
@media (min-width: 1024px) { .badge-icon { width: 48px; height: 48px; } }

.hero-title {
  font-size: 30px;
  font-weight: 700;
  color: #111827;
  line-height: 1.25;
  margin: 0;
}

@media (min-width: 768px) { .hero-title { font-size: 36px; } }
@media (min-width: 1024px) { .hero-title { font-size: 48px; } }

.hero-desc {
  font-size: 18px;
  color: #4b5563;
  line-height: 2;
  letter-spacing: 0.05em;
  margin: 0;
}

.desc-normal { color: #6b7280; }

.desc-highlight {
  color: #2563eb;
  font-weight: 700;
}

.desc-label {
  color: #374151;
  font-weight: 600;
}

.desc-slogan {
  color: #2563eb !important;
  font-weight: 700;
  font-size: 18px;
}

.hero-btns {
  display: flex;
  gap: 16px;
}

.btn-primary {
  background: #2563eb;
  color: #fff;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary:hover { background: #1d4ed8; }

.btn-secondary {
  background: #fff;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 12px 24px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover { background: #f9fafb; }

.btn-manual {
  background: #8b5cf6;
  color: #fff;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-manual:hover {
  background: #7c3aed;
}

/* 代码窗口 */
.code-window {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.15);
  overflow: hidden;
}

.code-header {
  background: #1f2937;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.code-dots { display: flex; gap: 8px; }
.dot { width: 12px; height: 12px; border-radius: 50%; }
.dot.red { background: #ef4444; }
.dot.yellow { background: #eab308; }
.dot.green { background: #22c55e; }

.code-filename {
  font-size: 12px;
  color: #9ca3af;
  margin-left: 8px;
}

.code-body {
  background: #111827;
  padding: 24px;
  font-size: 13px;
  font-family: '微软雅黑';
  line-height: 1.7;
}

.c-purple { color: #a78bfa !important; }
.c-yellow { color: #fde047 !important; }
.c-blue   { color: #60a5fa !important; }
.c-gray   { color: #9ca3af !important; }
.c-green  { color: #80ffb5 !important; }
.mt       { margin-top: 8px; }
.indent1  { padding-left: 16px; }
.indent2  { padding-left: 32px; }

/* ===== 通用 Section ===== */
.section { padding: 48px 0; }
.bg-gray  { background: #f9fafb; }
.bg-dot {
  background: #fff;
  background-image: radial-gradient(circle, #d1d5db 1px, transparent 1px);
  background-size: 30px 30px;
}

.section-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 32px;
}

.section-header {
  text-align: center;
  margin-bottom: 32px;
}

/* section-header: text-2xl md:text-3xl font-bold */
.section-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

@media (min-width: 768px) { .section-header h2 { font-size: 30px; } }

/* text-sm text-gray-600 */
.section-header p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* ===== 工作室介绍 ===== */
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

@media (max-width: 1024px) { .grid-4 { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 480px)  { .grid-4 { grid-template-columns: 1fr; } }

.intro-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 16px;
  position: relative;
  overflow: hidden;
  transition: border-color 0.2s;
  min-height: 120px;
}

.intro-card:hover { border-color: #2563eb; }

.intro-corner {
  position: absolute;
  top: 0; right: 0;
  width: 80px; height: 80px;
  border-bottom-left-radius: 100%;
}

.intro-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.intro-icon {
  width: 44px; height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.intro-icon svg { width: 22px; height: 22px; }

/* text-base lg:text-lg font-bold */
.intro-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  flex: 1;
}

@media (min-width: 1024px) { .intro-title { font-size: 18px; } }

/* text-xs lg:text-sm */
.intro-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.625;
  margin: 0;
}

@media (min-width: 1024px) { .intro-desc { font-size: 14px; } }

/* ===== 论文助手 ===== */
.bg-white { background: #fff; }

.grid-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}

@media (max-width: 1280px) { .grid-5 { grid-template-columns: repeat(4, 1fr); } }
@media (max-width: 1024px) { .grid-5 { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 768px) { .grid-5 { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 480px) { .grid-5 { grid-template-columns: 1fr; } }

.helper-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 16px;
  position: relative;
  overflow: hidden;
  transition: border-color 0.2s;
  min-height: 120px;
}

.helper-card:hover { border-color: #2563eb; }

.helper-corner {
  position: absolute;
  top: 0; right: 0;
  width: 80px; height: 80px;
  border-bottom-left-radius: 100%;
}

.helper-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.helper-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.helper-icon svg {
  width: 22px;
  height: 22px;
}

.helper-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  flex: 1;
  padding-right: 8px;
}

@media (min-width: 1024px) { .helper-title { font-size: 18px; } }

.helper-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.625;
  margin: 0;
}

@media (min-width: 1024px) { .helper-desc { font-size: 14px; } }

.helper-cta {
  text-align: center;
  margin-top: 32px;
}

/* ===== 技术栈 ===== */
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

@media (max-width: 768px) { .grid-3 { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 480px) { .grid-3 { grid-template-columns: 1fr; } }

.tech-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 24px;
  transition: border-color 0.2s;
}

.tech-card:hover { border-color: #2563eb; }

.tech-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.tech-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tech-icon img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

/* text-base font-bold */
.tech-card h3 {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}

/* text-sm */
.tech-card p {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* ===== 服务特色 ===== */
.feature-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 28px;
  transition: border-color 0.2s;
}

.feature-card:hover { border-color: #2563eb; }

.feature-top {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 16px;
}

.feature-icon {
  width: 48px; height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-icon svg { width: 24px; height: 24px; }

/* text-base font-semibold */
.feature-num {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

/* text-lg font-semibold */
.feature-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

/* text-sm */
.feature-desc {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.625;
  margin: 0;
}
</style>
